import { DayPicker, type Matcher } from 'react-day-picker';
import { tv } from 'tailwind-variants';
import type { Locale } from 'date-fns';

type Props = {
  month: Date;
  onMonthChange: (month: Date) => void;
  locale: Locale;
  disabled?: Matcher;
  selected: Date | undefined;
  onSelect: (date: Date | undefined) => void;
};

const classes = tv({
  slots: {
    day: 'text-primary headline4',
    weekday: 'text-secondary p5',
    today: 'text-primary',
    selected: 'rdp-date-selected',
    outside: '!text-stroke-light-bg !opacity-100',
    disabled: 'text-secondary !opacity-100',
  },
});

function Calendar({
  selected,
  onSelect,
  month,
  onMonthChange,
  locale,
  disabled,
}: Props) {
  const c = classes();

  return (
    <DayPicker
      mode="single"
      selected={selected}
      onSelect={onSelect}
      month={month}
      onMonthChange={onMonthChange}
      locale={locale}
      disabled={disabled}
      components={{
        CaptionLabel: () => <></>,
        MonthCaption: () => <></>,
        NextMonthButton: () => <></>,
        PreviousMonthButton: () => <></>,
      }}
      showOutsideDays
      classNames={{
        day: c.day(),
        weekday: c.weekday(),
        today: c.today(),
        selected: c.selected(),
      }}
      modifiersClassNames={{
        outside: c.outside(),
        disabled: c.disabled(),
      }}
    />
  );
}

export { Calendar };
